import { ReactNode } from 'react'

export default function Background({ children }:{children:ReactNode}) {
	return(
		<div id="backgroundPanel">
			{ children }
		</div>
	)
}